import * as React from "react"
import {Box, MenuItem} from "@mui/material";
import {IconSeeker} from "@ui-seeker/core";

import {handleLangPopoverClose} from "./signals";


// `icon`: an IconSeeker name, or an element (Iris's mark in "Iris settings", CU-869fmherf)
export default function MaximalLayoutHeaderUserOption({ icon, text }) {
	return <MenuItem onClick={handleLangPopoverClose}>
		{typeof icon === 'string' ? <IconSeeker icon={icon} /> : icon}
		<Box component="span" sx={{ ml: 1 }}>
			{text}
		</Box>
	</MenuItem>
}